import appConstants from "../../../../../appConstants";
import { DropdownEditor } from "../../../../dataGrid/cellEditors";
import {DropdownValueCellRenderer} from "../../../../dataGrid/cellRenderer";

export default class GridConfig {
    constructor(configuration){
        const config = configuration || {};
        this.name = "GridConfiguration";
        this.config = GridConfig.getConfiguration(config);
    }
    static getConfiguration(config) {
      return GridConfig.getDefaultConfiguration();
    }

    
    static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.RouteEquipmentPreference,
      keyColumn: "routeName",
      columns: [
        {
          headerName: "Route",
          field: "routeName",
          headerTooltip: "Route",
          minWidth: appConstants.columnWidth.ROUTE_EQMT_MAP_ROUTE,
        },
        {
          headerName: "Trailer",
          field: "trailerName",
          headerTooltip: "Trailer",
          editable: true,
          cellEditorFramework: DropdownEditor,
          minWidth: appConstants.columnWidth.ROUTE_EQMT_MAP_TRAILER,
          cellRenderer: DropdownValueCellRenderer,
        }     
      ]
    }
  }
}

